import React from 'react';
import withOptimizely from '../utils/withOptimizely';
import { useDecision } from '@optimizely/react-sdk';
import { shape, object, string, func, oneOfType, arrayOf } from 'prop-types';

const propTypes = {
    optimizely: shape({
        initialConfig: shape({
            datafile: object
        })
    }),
    feature: oneOfType([
        string,
        arrayOf(string)
    ]),
    children: func.isRequired
};

export const Feature = props => {
    const { optimizely, feature, children } = props;

    if (!optimizely?.initialConfig?.datafile) return <>{children({ ...props })}</>

    // To allow feature segmentation (for example separate feature for mobile and web)
    const featureArray = Array.isArray(feature) ? feature : [feature]
    const decision = getDecision(featureArray)

    return <>{children({ ...props, ...decision })}</>
};

Feature.propTypes = propTypes;

export default withOptimizely(Feature);

const getDecision = ([ firstFeature, ...rest ] = []) => {
    const [{ enabled, variationKey, variables }] = useDecision(firstFeature);
    let featureToUse = { isEnabled: enabled, variationKey, variables, feature: firstFeature };
    
    // If multiple features are enabled, picks the last one
    if (rest.length > 0) {
        for (const feature of rest) {
            const [{ enabled, variationKey, variables }] = useDecision(feature);
            if (enabled) featureToUse = { isEnabled: enabled, variationKey, variables, feature }
        }
    }

    return featureToUse
}